<template>
  <button class="flex justify-center bg-bgbutton py-2 rounded-lg shadow" :disabled="loading"
          @touchstart="toggleAnimation($event)" @touchend="toggleAnimation($event)">
    <LoadingSpinner class="w-6 ml-2 !text-gray-500" v-if="loading"/>
    <slot></slot>
  </button>
</template>

<script>
import LoadingSpinner from "@/components/General/LoadingSpinner";
export default {
  name: "VButton",
  props: ['loading'],
  components: {LoadingSpinner},
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('bg-amber-300')
    }
  }
}
</script>

<style scoped>

</style>